import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Box,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import { OrgExternalEmailNotifications, OrgExternalGeneralNotifications } from 'models/organization';

type ExternalTechnicianNotificationSettingTableProps = {
    externalGeneralNotifications: OrgExternalGeneralNotifications;
    externalEmailNotifications: OrgExternalEmailNotifications;
    handleExternalGeneralNotifications: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleExternalEmailNotifications: (event: React.ChangeEvent<HTMLInputElement>) => void;
};
const ExternalTechnicianNotificationSettingTable: FC<ExternalTechnicianNotificationSettingTableProps> = ({
    externalGeneralNotifications,
    externalEmailNotifications,
    handleExternalGeneralNotifications,
    handleExternalEmailNotifications,
}: ExternalTechnicianNotificationSettingTableProps) => {
    const { t: translate } = useTranslation(['lab-settings']);

    return (
        <Box mb={4}>
            <Typography variant="h3">{translate('lab-settings:EXTERNAL_TECHNICIAN_NOTIFICATIONS')}</Typography>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell width="60%">{translate('lab-settings:NOTIFICATION')}</TableCell>
                            <TableCell>{translate('lab-settings:IN_APPLICATION')}</TableCell>
                            <TableCell>{translate('common:EMAIL')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>{translate('lab-settings:INTERNAL_MESSAGE_RECEIVED')}</TableCell>
                            <TableCell>
                                <Switch
                                    checked={externalGeneralNotifications.newInternalMessage}
                                    onChange={handleExternalGeneralNotifications}
                                    name="newInternalMessage"
                                />
                            </TableCell>
                            <TableCell>
                                <Switch
                                    checked={externalEmailNotifications.newInternalMessage}
                                    onChange={handleExternalEmailNotifications}
                                    name="newInternalMessage"
                                />
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell>{translate('lab-settings:INTERNAL_ORDER_MODIFIED')}</TableCell>
                            <TableCell>
                                <Switch
                                    checked={externalGeneralNotifications.internalOrderModified}
                                    onChange={handleExternalGeneralNotifications}
                                    name="internalOrderModified"
                                />
                            </TableCell>
                            <TableCell>
                                <Switch
                                    checked={externalEmailNotifications.internalOrderModified}
                                    onChange={handleExternalEmailNotifications}
                                    name="internalOrderModified"
                                />
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell>{translate('lab-settings:ORDER_MODIFIED')}</TableCell>
                            <TableCell>
                                <Switch
                                    checked={externalGeneralNotifications.orderModified}
                                    onChange={handleExternalGeneralNotifications}
                                    name="orderModified"
                                />
                            </TableCell>
                            <TableCell>
                                <Switch
                                    checked={externalEmailNotifications.orderModified}
                                    onChange={handleExternalEmailNotifications}
                                    name="orderModified"
                                />
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell>{translate('lab-settings:ORDER_DECLINED')}</TableCell>
                            <TableCell>
                                <Switch
                                    checked={externalGeneralNotifications.orderDeclined}
                                    onChange={handleExternalGeneralNotifications}
                                    name="orderDeclined"
                                />
                            </TableCell>
                            <TableCell>
                                <Switch
                                    checked={externalEmailNotifications.orderDeclined}
                                    onChange={handleExternalEmailNotifications}
                                    name="orderDeclined"
                                />
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell>{translate('lab-settings:ASSIGN_EXTERNAL_TECHNICIAN')}</TableCell>
                            <TableCell>
                                <Switch
                                    checked={externalGeneralNotifications.assignExtTech}
                                    onChange={handleExternalGeneralNotifications}
                                    name="assignExtTech"
                                />
                            </TableCell>
                            <TableCell>
                                <Switch
                                    checked={externalEmailNotifications.assignExtTech}
                                    onChange={handleExternalEmailNotifications}
                                    name="assignExtTech"
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default ExternalTechnicianNotificationSettingTable;
